import React, { useEffect } from 'react';
import { Grid, Paper, Typography, Switch, FormControlLabel } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';
import T from 'i18n';
import { ToggleButton } from 'features/common';

const steps = [
  { key: 'reindexOcr', label: T.translate('case.waterfall.ocr') || 'OCR' },
  { key: 'reindexGenerateXml', label: T.translate('case.waterfall.xml') || 'XML' },
  { key: 'reindexGenerateJson', label: T.translate('case.waterfall.json') || 'JSON' },
  {
    key: 'reindexUpdateSearchIndex',
    label: T.translate('case.waterfall.azureSearch') || 'Azure Search',
  },
  {
    key: 'reindexExtractDates',
    label: T.translate('case.waterfall.dateExtraction') || 'Date Extraction',
  },
  {
    key: 'reindexUpdatePinecone',
    label: T.translate('case.waterfall.embeddings') || 'Embeddings',
  },
];

const NewReindexContent = ({ pipelineVersion, setValuesHaveNotBeenSelected }) => {
  const { control, watch, setValue } = useFormContext();
  const values = watch(steps.map((s) => s.key));
  const firstCheckedIndex = values.findIndex((v) => v);

  const handleToggle = (index) => (event) => {
    const checked = event.target.checked;
    steps.forEach((_, idx) => {
      if (idx >= index) {
        setValue(steps[idx].key, checked, {
          shouldValidate: false,
          shouldDirty: true,
        });
      }
    });
  };
  // if at least one value has been selected, set the flag
  useEffect(() => {
    if (values.some((v) => v)) {
      setValuesHaveNotBeenSelected(false);
    } else {
      setValuesHaveNotBeenSelected(true);
    }
  }, [values, setValuesHaveNotBeenSelected]);

  return (
    <>
      <Grid container direction="column" spacing={1} padding={1}>
        {steps.map((step, index) => (
          <Grid item xs={12} key={step.key}>
            <Controller
              name={step.key}
              control={control}
              defaultValue={false}
              render={({ field: { value, onChange, ref } }) => (
                <FormControlLabel
                  control={
                    <Switch
                      checked={value}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        onChange(checked);
                        handleToggle(index)(e);
                      }}
                      name={step.key}
                      inputRef={ref}
                      disabled={false || (firstCheckedIndex !== -1 && index > firstCheckedIndex)}
                      as={ToggleButton}
                      sx={{ width: '5rem' }}
                    />
                  }
                  label={step.label}
                  labelPlacement="start"
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '90%',
                    margin: 0,
                  }}
                />
              )}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default NewReindexContent;
